import { objectGetKeys } from '../../../utils/ieCompatibility'
import { AppartementGenreEnum } from './appartementGenreEnum'

export enum GenreFiltreOffreEnum {
	TOUS = 0,
	STUDIO = 1,
	PIECE2 = 2,
	PIECE3 = 3,
	PIECE4 = 4
}

export const STUDIO_FILTER = [AppartementGenreEnum.CHAMBRE, AppartementGenreEnum.STUDIO, AppartementGenreEnum.T1, AppartementGenreEnum.T1BIS]
export const PIECE2_FILTER = [AppartementGenreEnum.T2, AppartementGenreEnum.PIECES2]
export const PIECE3_FILTER = [AppartementGenreEnum.T3, AppartementGenreEnum.PIECES3]
export const PIECE4_FILTER = [AppartementGenreEnum.PIECES4, AppartementGenreEnum.PIECES5, AppartementGenreEnum.PIECES6, AppartementGenreEnum.PIECES7, AppartementGenreEnum.T4, AppartementGenreEnum.T5, AppartementGenreEnum.T6, AppartementGenreEnum.T8]

export const getKeyFromGenreFiltreOffreValue = (value: number) => objectGetKeys(GenreFiltreOffreEnum).find((genreFiltreOffre) => GenreFiltreOffreEnum[genreFiltreOffre as keyof typeof GenreFiltreOffreEnum] === value)